exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-button_share-button_Nxxf0 {\n    background: hsla(55, 90%, 60%, 1);\n    color: hsla(55, 90%, 95%, 1);\n    box-shadow: 0 0 0 1px var(--ui-black-transparent, hsla(55, 20%, 20%, 0.15));\n}\n[theme=\"dark\"] .share-button_share-button_Nxxf0 {\n    background: transparent;\n    color: hsla(55, 90%, 95%, 1);\n    box-shadow: 0 0 0 1px var(--ui-black-transparent, hsla(55, 20%, 20%, 0.15));\n}\n.share-button_share-button-is-shared_1tjKq {\n    background: var(--ui-black-transparent, hsla(55, 20%, 20%, 0.15));\n    cursor: default;\n}\n", ""]);

// exports
exports.locals = {
	"share-button": "share-button_share-button_Nxxf0",
	"shareButton": "share-button_share-button_Nxxf0",
	"share-button-is-shared": "share-button_share-button-is-shared_1tjKq",
	"shareButtonIsShared": "share-button_share-button-is-shared_1tjKq"
};